'use client'
import { useResponsiveSize } from "@/provider/useResponsiveSize"
import { createContext, ReactNode, useContext, useEffect, useRef } from "react"
import { create, StoreApi } from "zustand"
import { useShallow } from "zustand/react/shallow"
import { asideVariants } from "./SideBar"

type HeaderState = 'default' | 'outline' | 'hidden'
type AsideState = keyof typeof asideVariants
type AsideWrapperState = 'hidden' | 'default'

type RootLayoutStore = {
  header: HeaderState,
  aside: AsideState,
  asideWrapper: AsideWrapperState
  setHeader: (header: HeaderState) => any
  setAside: (aside: AsideState) => any
  setAsideWrapper: (aside: AsideWrapperState) => any
}

const createInitializer = (values: any = {}) => {
  return (set, get): RootLayoutStore => {
    return ({
      header: 'default',
      aside: null!,
      asideWrapper: null!,
      setHeader: (header) => set({ header }),
      setAside: (aside: string) => set({ aside }),
      setAsideWrapper: (asideWrapper: string) => set({ asideWrapper }),
      ...values
    })
  }
}

const StoreContext = createContext<{ store: StoreApi<RootLayoutStore> } | null>(null)

export const RootLayoutProvider = ({ children }: { children: ReactNode }) => {
  const size = useResponsiveSize(['default', 'lg'])
  const storeRef = useRef<any>(null!)
  const store = storeRef.current || create(createInitializer({
    asideWrapper: size === 'lg' ? 'default' : 'hidden'
  }))
  storeRef.current = store


  return (
    <StoreContext.Provider value={{ store: storeRef.current }} >
      {children}
    </StoreContext.Provider>
  )
}




export const useRootLayout = <T,>(selector: (store: RootLayoutStore) => T): T => {
  const store = useContext(StoreContext)!.store
  if (!store) throw new Error('useMyStore must be used inside AiAgentStore')
  // 调用方普遍返回数组（[state.a, state.b]），默认 Object.is 比较会让任一字段变化都触发重渲染；
  // 挂载后侧栏/头部的 effect 会连续写 store，导致 Layout + Header 整块重渲染（低端机数十毫秒级长任务）
  return store(useShallow(selector))
}
